import { Navigate, Outlet } from "react-router-dom";
import { toastWarning } from "./Helpers/toasts";

export const ProtectedRoute = ({ isAllowed, redirectPath = "/", children }) => {
  if (!isAllowed) {
    toastWarning("Sahifaga kirish huquqingiz yoq!");
    return <Navigate to={redirectPath} replace />;
  }

  return children ? children : <Outlet />;
};
